<template>
  <div class="field-error">{{ text }}</div>
</template>

<script>
export default {
  name: "FieldError",
  props: {
    text: String
  }
};
</script>

<style scoped>
.field-error {
  color: red;
}
</style>
